import styled, { createGlobalStyle, keyframes } from 'styled-components'
import RoomChargeIcon from '../../../img/svg/roomCharge'
import { theme } from '../../../style/theme'
import { colorTheme } from '../../../style/theme/colorTheme'

export const RoomChargeModalGlobalStyle = createGlobalStyle`
	#room-charge-modal h2 {
		display: none;
	}
`

export const RoomChargeModalBody = styled.div`
	font-size: 1rem;
	font-family: ${theme.fontRoboto};
	text-align: left;
	color: ${colorTheme.roomCharge.modal.title};
`
RoomChargeModalBody.displayName = 'RoomChargeModalBody'

export const RoomChargeModalSteps = styled.div`
	margin-top: 2.75em;
	display: flex;
	flex-direction: column;
	gap: 1.25em;
	min-height: 40em;

	@media screen and (max-width: ${theme.point820}) {
		margin-top: 1.25em;
	}
`
RoomChargeModalSteps.displayName = 'RoomChargeModalSteps'

export const RoomChargeActionButton = styled.button`
	font-size: 1.25em;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.6em;
	width: 100%;
	height: 2.75em;
	border-radius: 0.6em;
	font-weight: 500;
	transition: all 0.2s;
	background: ${colorTheme.roomCharge.modal.primaryButton.background};
	color: ${colorTheme.roomCharge.modal.primaryButton.text};

	&:hover:not(:disabled) {
		filter: brightness(1.05);
	}

	&:disabled {
		background: ${colorTheme.roomCharge.modal.primaryButton.disabled};
	}
`
RoomChargeActionButton.displayName = 'RoomChargeActionButton'

export const RoomChargeConfirmButton = styled(RoomChargeActionButton)`
	flex-grow: 1;
	flex-basis: 12.8em;
	background: ${colorTheme.roomCharge.modal.confirmButton.background};
`
RoomChargeConfirmButton.displayName = 'RoomChargeConfirmButton'

export const RoomChargeSecondaryButton = styled(RoomChargeActionButton)`
	flex-grow: 1;
	flex-basis: 12.8em;
	border: 1px solid ${colorTheme.roomCharge.modal.secondaryButton.border};
	background: ${colorTheme.roomCharge.modal.secondaryButton.background};
	color: ${colorTheme.roomCharge.modal.secondaryButton.text};

	&:hover:not(:disabled) {
		filter: none;
		background: ${colorTheme.roomCharge.modal.secondaryButton.hover};
	}

	&:disabled {
		opacity: 0.4;
		background: ${colorTheme.roomCharge.modal.secondaryButton.background};
	}

	&.muted {
		flex-basis: auto;
		color: ${colorTheme.roomCharge.modal.secondaryButton.mutedText};
	}
`
RoomChargeSecondaryButton.displayName = 'RoomChargeSecondaryButton'

const spin = keyframes`
	to {
		transform: rotate(360deg);
	}
`

export const RoomChargeActionIcon = styled(RoomChargeIcon)`
	flex-shrink: 0;
	width: 1.1em;
	height: 1.1em;

	&.spinning {
		animation: ${spin} 1s linear infinite;
	}
`
RoomChargeActionIcon.displayName = 'RoomChargeActionIcon'

export const RoomChargeStepHint = styled.p`
	display: flex;
	align-items: center;
	gap: 0.43em;
	font-size: 0.87em;
	color: ${colorTheme.roomCharge.modal.errorText};
`
RoomChargeStepHint.displayName = 'RoomChargeStepHint'

export const RoomChargeStepHintIcon = styled(RoomChargeIcon)`
	flex-shrink: 0;
	width: 0.93em;
	height: 0.93em;
`
RoomChargeStepHintIcon.displayName = 'RoomChargeStepHintIcon'
